const ThemesColors = {
    iceBlue: "#F2FAFF",
    popoverBackground: "#FFFFFF",
    gray25: "#FCFCFD",
    gray50: "#F9FAFB",
    gray100: "#F2F4F7",
    gray200: "#EAECF0",
    gray300: "#D0D5DD",
    gray400: "#98A2B3",
    gray500: "#667085",
    gray600: "#475467",
    gray700: "#344054",
    gray800: "#1D2939",
    gray900: "#101828",
    mainBlueRGB: "rgb(143 213 245)",
    mainBlueLight25: "#F5FBFF",
    mainBlueLight50: "#F0F9FF",
    mainBlueLight100: "#E0F2FE",
    mainBlueDark200: "#B9E6FE",
    mainBlueDark300: "#7CD4FD",
    mainBlueDark400: "#36BFFA",
    mainBlueDark500: "#0BA5EC",
    mainBlueDark600: "#0086C9",
    mainBlueDark700: "#026AA2",
    mainBlueDark800: "#065986",
    mainBlueDark900: "#0B4A6F",
    warningColor: "#FAAD14",
    errorIndigo25: "#F5F8FF",
    errorIndigo50: "#EEF4FF",
    errorIndigo100: "#E0EAFF",
    errorIndigo200: "#C7D7FE",
    errorIndigo300: "#A4BCFD",
    errorIndigo400: "#8098F9",
    errorIndigo500: "#6172F3",
    errorIndigo600: "#444CE7",
    errorIndigo700: "#3538CD",
    errorIndigo800: "#2D31A6",
    errorIndigo900: "#2D3282",
    error25: "#FFFBFA",
    error50: "#FEF3F2",
    error100: "#FEE4E2",
    error200: "#FECDCA",
    error300: "#FDA29B",
    error400: "#F97066",
    error500: "#F04438",
    error600: "#D92D20",
    error700: "#B42318",
    error800: "#912018",
    error900: "#7A271A",
    azureBlue: "#1890FF",
    skyBlue: "#34c2fa",
    textColorLight: "#838383",
};

// TODO : Switch to full css variables
const LightModeColors = {
    ...ThemesColors,
};

// TODO : Switch to full css variables
const DarkModeColors = {
    ...ThemesColors,
};

const FontSize = {
    xxx: "72px",
    xxl: "46px",
    xl: "36px",
    lg: "24px",
    md: "20px",
    ms: "18px",
    mg: "16px",
    sm: "14px",
    xs: "12px",
    medium: "26px",
};

const FontWeight = {
    bold: 600,
    normal: 400,
    medium: 500,
};

const FontFamily = {
    baloo: '"Baloo Bhai", serif',
    poppins: '"Poppins", sans-serif',
    poppinsRegular: "Poppins-Regular",
    poppinsBlack: '"Poppins-Black", sans-serif',
    montserratBlack: '"Montserratarm-Black", sans-serif',
    montserratBold: '"Montserratarm-Bold", sans-serif',
    montserratExtraBold: '"Montserratarm-ExtraBold", sans-serif',
    montserratExtraLight: '"Montserratarm-ExtraLight", sans-serif',
    montserratRegular: '"Montserratarm-Regular", sans-serif',
    montserratSemiBold: '"Montserratarm-SemiBold", sans-serif',
    montserratThin: '"Montserratarm-Thin", sans-serif',
    montserratLight: '"Montserratarm-Light", sans-serif',
    montserratBlackItalic: "Montserrat-BlackItalic, sans-serif",
};

export { FontFamily, FontSize, FontWeight, ThemesColors, LightModeColors, DarkModeColors };
